<template>
  <div>
    <SideBar></SideBar>
    <Main></Main>
  </div>
</template>
<script>
import SideBar from "@/pages/layout/SideBar";
import Main from "@/pages/layout/Main";

export default {
  name: "Layout",
  components: { Main, SideBar }
};
</script>


// WEBPACK FOOTER //
// src/pages/layout/index.vue